export default "/images/vendor/flag-icons/flags/4x3/pn.svg?c95dddcdc16e2c3e0ec045539e1d7d01";